/* ========================================================================
 * .noConflict()
 * Enclosed everything within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
	
	$.fn.isOnScreen = function(){
	      
	  var win = $(window);
	      
	  var viewport = {
	    top : win.scrollTop(),
	    left : win.scrollLeft()
	  };
	  
	  viewport.right = viewport.left + win.width();
	  viewport.bottom = viewport.top + win.height();
	      
	  var bounds = this.offset();
	      bounds.right = bounds.left + this.outerWidth();
	      bounds.bottom = bounds.top + this.outerHeight();
	      
	  return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
	      
	};

	/// load foundation
	$(document).foundation();
	
	/// matchHeight
	$('.news .new-related h3.article-title').matchHeight();

	/// do animations 
	setTimeout(function() { 
		$('.navbar').addClass('show');
	}, 100);

	$('section').velocity('fadeIn', { duration: 750 });
	$('footer').velocity('fadeIn', { duration: 750 });

	setTimeout(function(){
		$('.logo').addClass('anim');
	}, 300);
	
	/// Scroll animations
	$(window).on('scroll', function () {
		var scroll = $(this).scrollTop();
		
		if(scroll > 100) {
			$('.navbar').addClass('scroll');
		} else {
			$('.navbar').removeClass('scroll');
		}
		
		if(scroll > 500) {
			$('.sticky-cta .bottom-bar').addClass('scroll');
		} else {
			$('.sticky-cta .bottom-bar').removeClass('scroll');
		}

		$('.scrollDiv.start').each(function(){
		  if($(this).isOnScreen()) {
		      scrollDistance = $(this).attr('data-scroll');
		      scrollDiv = (scrollDistance / $(window).outerHeight()) * ($(this).offset().top - scroll);

		      if(scrollDiv < scrollDistance) {
		          $(this).css('transform', 'translate3d(0px, '+ scrollDiv +'px, 0px)')
		      }
		  }
		});

		lazy();
	});

	function lazy() {
		$('img.lazy').each(function(){
			if($(this).isOnScreen()){
				$(this).attr('src', $(this).attr('data-src'));
				$(this).removeClass('lazy');

				if($(this).parent().hasClass('liquid')) {
					$(this).parent().css('background-image', 'url(' + $(this).attr('data-src') + ')');
				}
			}
		});
	} lazy();

	$('.liquid').imgLiquid();
	
	/// Sliders
	$('.logo-slider').slick({
	  dots: false,
	  arrows: true,
	  infinite: true,
	  speed: 300,
	  autoplay: true,
	  autoplaySpeed: 2000,
	  slidesToShow: 5,
	  slidesToScroll: 1,
	  nextArrow: '<div class="right"><i class="fa fa-arrow-circle-right"></i></div>',
  	  prevArrow: '<div class="left"><i class="fa fa-arrow-circle-left"></i></div>',
  	  responsive: [
  	    {
  	      breakpoint: 1300,
  	      settings: {
  	        slidesToShow: 3,
  	        arrows: false
  	      }
  	    },
  	    {
  	      breakpoint: 820,
  	      settings: {
  	        slidesToShow: 2,
  	        arrows: false
  	      }
  	    },
  	    {
  	      breakpoint: 570,
  	      settings: {
  	        slidesToShow: 1,
  	        arrows: false
  	      }
  	    }
  	  ]
	});

	/// page transition
	$('a').click(function(e){
		if($(this).hasClass('direct') != true) {
			if($(this).hasClass('questions') != true) {
				if($(this).attr('target') !== '_blank') {
					e.preventDefault();

					var goTo = $(this).attr('href');
					$('.navbar').removeClass('show');
					$('section').velocity('fadeOut');
					$('a.hero').velocity('fadeOut');
					$('footer').velocity('fadeOut');
					$('body').css('background', 'none');
					$('.big-dropdown').hide();
					$('body').removeClass('pushy-open-right');
					window.location.href = goTo;
				}
			}
		}
	});

	/// faq items
	$('.faq_title').click(function(){
		$(this).parent().toggleClass('active');
	});

	/// bottom CTA
	$('.sticky-cta .bottom-bar').click(function(){
		$('.sticky-cta .cta_overlay').velocity('fadeIn');
		$('body').addClass('modal-open');
	});

	$('.sticky-cta .close').click(function(){
		$('.sticky-cta .cta_overlay').velocity('fadeOut');
		$('body').removeClass('modal-open');
	});

	/// show dropdown menu
	$('.navbar li.show-dropdown').on('mouseenter', function (event) {
	    $('.big-dropdown').show();
	});

	$('.navbar ul.vertical li').on('mouseenter', function (event) {
		console.log($(this).hasClass('.show-dropdown'));
		if($(this).hasClass('show-dropdown') == false) {
			$('.big-dropdown').hide();
		}
	});

	$('.big-dropdown').on('mouseleave', function (event) {
	    $('.big-dropdown').hide();
	});

})(jQuery); // Fully reference jQuery after this point.